import React, { useEffect } from 'react';

function InfraPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="subcustom-header-container">
      <header className="subcustom-header">
        <div className="hero-title-area">
          <div className="hero-subtitle">INFRASTRUCTURE</div>
          <h2 className="hero-title">인프라</h2>
        </div>
      </header>
      
      <div className="breadcrumb">
        <span>HOME</span>
        <span>상용 인프라 소프트웨어</span>
      </div>
      
      <main className="infra-main">
        <h3 className="infra-title">WEB/WAS 서버 소프트웨어</h3>
        <hr className="infra-divider" />
        
        <section className="infra-section">
          <div className="infra-info">
            <div className="infra-label">OS</div>
            <h4 className="infra-section-title">운영체제</h4>
            <div className="infra-list-wrap">
              <ul className="infra-list">
                <li>Red Hat Enterprise Linux</li>
              </ul>
            </div>
          </div>
          <div className="infra-img">
            <img src="/test_img.png" alt="OS 이미지" />
          </div>
        </section>
        
        <section className="infra-section">
          <div className="infra-info">
            <div className="infra-label">Middleware</div>
            <h4 className="infra-section-title">미들웨어</h4>
            <div className="infra-list-wrap">
              <ul className="infra-list">
                <li>JBoss Red Hat</li>
                <li>Red Hat OpenShift</li>
                <li>LgCNS LENA</li>
                <li>Resin</li>
              </ul>
            </div>
          </div>
          <div className="infra-img">
            <img src="/test_img.png" alt="미들웨어 이미지" />
          </div>
        </section>
        
        <section className="infra-section">
          <div className="infra-info">
            <div className="infra-label">DB</div>
            <h4 className="infra-section-title">상용 데이터베이스</h4>
            <div className="infra-list-wrap">
              <ul className="infra-list">
                <li>Oracle</li>
                <li>TmaxTibero</li>
                <li>AgensSql</li>
              </ul>
            </div>
          </div>
          <div className="infra-img">
            <img src="/test_img.png" alt="DB 이미지" />
          </div>
        </section>
        
        <section className="infra-section">
          <div className="infra-info">
            <div className="infra-label">Monitoring</div>
            <h4 className="infra-section-title">모니터링 솔루션</h4>
            <div className="infra-list-wrap">
              <ul className="infra-list">
                <li>Jennifer</li>
                <li>MaxGauge</li>
                <li>eG Enterprise</li>
                <li>TAMIS</li>
              </ul>
            </div>
          </div>
          <div className="infra-img">
            <img src="/test_img.png" alt="모니터링 이미지" />
          </div>
        </section>
        
        <section className="infra-section">
          <div className="infra-info">
            <div className="infra-label">Specialized Deployment Support</div>
            <h4 className="infra-section-title">이중화 구성</h4>
            <div className="infra-list-wrap">
              <ul className="infra-list">
                <li>Red Hat High Availability</li>
                <li>SUSE High Availability</li>
                <li>Pacemaker</li>
              </ul>
              <ul className="infra-list">
                <li>JBoss Session Cluster</li>
                <li>Apache to Tomcat Session Cluster</li>
              </ul>
            </div>
          </div>
          <div className="infra-img">
            <img src="/test_img.png" alt="이중화 구성 이미지" />
          </div>
        </section>
      </main>
    </div>
  );
}

export default InfraPage; 